import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import { ThumbnailsDict } from '@models/module/fields/main';

const DEFAULT_MIME_TYPE: string = 'image/png';

@Component({
  selector: 'cipo-img-base64',
  template: `
    <img
      [src]="src()"
      [width]="width()"
      [height]="height()"
      [attr.alt]="alt()"
      class="cipo-base64"
      [ngStyle]="{ 'border-radius': radius(), 'max-width': maxWidth() + 'px', 'max-height': maxHeight() + 'px' }"
      [ngClass]="{ 'cipo--width--auto': !width(), 'cipo--height--auto': !height() }"
    />
  `,
  imports: [CommonModule],
})
export class CipoImgBase64 {
  readonly base64 = input<string>();
  readonly alt = input<string>('');
  readonly placeholder? = input<string>();
  readonly mimetype? = input<string, string>(DEFAULT_MIME_TYPE, {
    transform: mimetype => mimetype ?? DEFAULT_MIME_TYPE,
  });
  readonly width = input<number>();
  readonly maxWidth = input<number>();
  readonly height? = input<number>();
  readonly maxHeight = input<number>();
  readonly radius? = input<string>();
  readonly src = computed(() => {
    const base64 = this.base64();

    if (base64) {
      return `data:${this.mimetype()};base64, ${base64}`;
    } else if (this.placeholder()) {
      return this.placeholder();
    } else {
      return ThumbnailsDict[this.mimetype()] ?? ThumbnailsDict.default;
    }
  });
}
